import { homApi } from '~/redux/apis/hom'

import { TMultGameRound, THighScore, TStat, TWorkoutQuestion, TStatFilters } from '~/games/types/multgame.types'

export const multgameApi = homApi.injectEndpoints({
  endpoints: (builder) => ({
    submitRound: builder.mutation<{ type: 'success' | 'error' }, TMultGameRound>({
      query: (data) => ({
        url: '/v2/multgame/rounds',
        method: 'POST',
        body: data,
      }),
    }),
    getMultGameStats: builder.query<TStat[], TStatFilters>({
      query: (params) => ({
        url: '/v2/multgame/stats',
        method: 'GET',
        params,
      }),
    }),
    getHighScores: builder.query<THighScore[], void>({
      query: () => ({
        url: '/v2/multgame/high-scores',
        method: 'GET',
      }),
    }),
    getWorkoutQuestions: builder.query<TWorkoutQuestion[], void>({
      query: () => ({
        url: '/v2/multgame/workout',
        method: 'GET',
      }),
    }),
    createWorkoutQuestions: builder.mutation<void, Omit<TWorkoutQuestion, 'id' | 'userId'>>({
      query: (data) => ({
        url: '/v2/multgame/workout',
        method: 'POST',
        body: data,
      }),
    }),
    updateWorkoutQuestions: builder.mutation<void, number[]>({
      query: (data) => ({
        url: '/v2/multgame/workout',
        method: 'PATCH',
        body: data,
      }),
    }),
  }),
})

export const {
  useSubmitRoundMutation,
  useLazyGetHighScoresQuery,
  useLazyGetMultGameStatsQuery,
  useLazyGetWorkoutQuestionsQuery,
  useUpdateWorkoutQuestionsMutation,
  useCreateWorkoutQuestionsMutation,
} = multgameApi
